import { Component, EventEmitter, OnInit, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ContactUsService } from '../core/services/contact-us.service';
import { LanguageService } from '../core/services/language.service';
import { ProductCategoryFieldsComponent } from '../core/components/product-category-fields/product-category-fields.component';

@Component({
  selector: 'app-req-policy-doc',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ProductCategoryFieldsComponent],
  templateUrl: './req-policy-doc.component.html',
  styleUrl: './req-policy-doc.component.css'
})
export class ReqPolicyDocComponent implements OnInit, OnDestroy {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  form: FormGroup;
  showPolicyNumber = false;
  private destroy$ = new Subject<void>();

  private readonly INT_REGION_CATEGORIES = [
    'Accidents des personnes',
    'Risques spéciaux',
    'Transport'
  ];

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService, private languageService: LanguageService) {}

  ngOnInit() {

    const lang = this.languageService.getLanguageFromUrl();

    this.lang = lang;

    this.form = this.fb.group({
      region: [lang === 'fr-fr' ? 'FR' : lang === 'en-us' ? 'US' : '', lang === 'en' ? [Validators.required] : []],
      productCategory: ['', [Validators.required]],
      productCategoryId: [''],
      otherInsurance: [''],
      product: ['', [Validators.required]],
      productId: [''],
      otherProduct: [''],
      policyNumber: [''],
      description: ['', [Validators.required, Validators.minLength(20)]]
    });

    if (lang === 'fr-fr') {
      this.form.get('productCategory')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
        this.form.get('region')?.setValue(this.INT_REGION_CATEGORIES.includes(value) ? 'INT' : 'FR');
      });
    }

    this.formReady.emit(this.form);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  togglePolicyNumberVisibility(): void {
    this.showPolicyNumber = !this.showPolicyNumber;
  }

  lang: string = '';

  get labels() { return this.contactUsService.commonLabels; }
  get placeholders() { return this.contactUsService.placeholderTextLabels; }
  get messages() { return this.contactUsService.messageLabels; }
}
